// Referral codes on the web arrive as a link parameter, e.g.
//   https://borku.../?ref=ABC123   or   https://borku.../#/?ref=ABC123
// The app gets the same code from its Branch deep link. It is kept until an
// order is placed, then sent with that order -- the server decides whether the
// customer is still eligible (first order, not the referrer's own code).
const STORAGE_KEY = "borkuReferralCode";
const PARAM_NAMES = ["ref", "referral", "referralCode"];

function readParam(query) {
  const params = new URLSearchParams(query);
  for (const name of PARAM_NAMES) {
    const value = params.get(name);
    if (value && value.trim()) return value.trim();
  }
  return null;
}

export function captureReferralFromUrl() {
  try {
    const { search, hash } = window.location;
    const hashQuery = hash.includes("?") ? hash.slice(hash.indexOf("?")) : "";
    const code = readParam(search) || readParam(hashQuery);
    if (code) localStorage.setItem(STORAGE_KEY, code);
  } catch (e) {
    // storage blocked: the order simply goes without a referral code
  }
}

export function getReferralCodeForOrder() {
  try {
    return localStorage.getItem(STORAGE_KEY) || null;
  } catch (e) {
    return null;
  }
}

export function clearReferralCode() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // nothing to clear
  }
}
